export const comments_5129832 = {"data":{"data":[],"links":{}}}